<a
  class="logo"
  [routerLink]="['/consultations']"
  [class.not-user-select]="isHeaderShortened"
  [class.logo_lg]="(activeClinic$ | async).id === clinicIds.doctors4ua || (activeClinic$ | async).id === clinicIds.DentistOmnycare"
  [class.logo_md]="(activeClinic$ | async).id === clinicIds.YourBaby"
>
  <img [src]="'logo.svg' | imagePath" alt="Doctors4UA">
</a>
